export default __webpack_public_path__ + "static/media/reactBaLogo.82a5080d.svg";